import { get, post, patch, del } from './P3Api';

async function getAllVendorItemCustomers() {
    return get('vendorItemCustomerMappings');
}

async function getVendorItemCustomersByVendorItemId(vendorItemId) {
    const encodedVendorItemId = encodeURIComponent(vendorItemId);
    return get(`vendorItemCustomerMappings/?vendorItemId=${encodedVendorItemId}`);
}

async function getVendorItemCustomersByVendorCode(vendorCode) {
    const encodedVendorCode = encodeURIComponent(vendorCode);
    return get(`vendorItemCustomerMappings/?vendorCode=${encodedVendorCode}&size=1000`);
}

async function getVendorItemCustomersByVendorItemCustomerId(vendorItemCustomerId) {
    return get(`vendorItemCustomerMappings/?vendorItemCustomerId=${vendorItemCustomerId}`);
}

async function postVendorItemCustomer(body) {
    return post('vendorItemCustomerMappings', body);
}

async function patchVendorItemCustomer(vendorItemCustomerId, body) {
    return patch(`vendorItemCustomerMappings/${vendorItemCustomerId}`, body);
}

async function deleteVendorItemCustomer(vendorItemCustomerId) {
    return del(`vendorItemCustomerMappings/${vendorItemCustomerId}`);
}

async function getVendorForCustomerMapping(itemCode, customerCode) {
    return get(`vendorItemCustomerMappings/?itemCode=${itemCode}&customerCode=${customerCode}`);
}

export {
 getAllVendorItemCustomers, 
 getVendorItemCustomersByVendorItemId, 
 getVendorItemCustomersByVendorItemCustomerId, 
 postVendorItemCustomer, 
 patchVendorItemCustomer,
 deleteVendorItemCustomer,
 getVendorForCustomerMapping,
 getVendorItemCustomersByVendorCode
};
